// extracted by mini-css-extract-plugin
export default {"menu-btn":"styles_menu-btn__d07ou"};